<script>
  export let name;

  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';
  
  let item = [];
  let loading = false;
  let error = false;

  function fetchItems(name) {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getToolsItem', {name: name})
        .then(response => response.json())
        .then(response => item = response.result)
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  fetchItems(name);
</script>

<!-- HTML ----------------------------------------------------------------------->

{#if loading}
<!-- thumbs[TYPE].length === 0 && !galleryError -->
  <div class="lds-css">
    <div class="lds-eclipse"><div></div></div>
  </div>
  
{:else if item}
  <div id="containerItem" class="gallery-tools-item">
<!--    <i id="typeItem" class="fab fa-2x fa-{item.type.toLowerCase()} {item.type.toLowerCase()}"></i>-->
    <h2 id="titleItem" class="rowItem def_back">{item.title}</h2>
    <div id="bodyItem">
      <img src="{Constants.PUBLIC_TOOLS_IMAGES + item.name + Constants.TOOL_FILE_EXT}" alt="{item.name}" />
    </div>
    <div class="rowItem row-border-top">
      <p id="tool-detail-{item.name}" class="tool-detail">
        {@html item.descExt_en}
      </p>
    </div>
  </div>

{:else if error}
  <div class="gallery-error">
    <i class="far fa-times-circle"></i>
    {$_('errors.UNKNOWN')}
  </div>
{/if}

<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

$type-lighten: 15%;

* {
  box-sizing: border-box;
}

#containerItem {
  #typeItem {
    text-shadow: 0 1px 1px $idro-palette-black;
    &.java { color: lighten($idro-skill-java, $type-lighten); }
    &.android { color: lighten($idro-skill-android, $type-lighten); }
    &.html5 { color: lighten($idro-skill-html5, $type-lighten); }
    &.js { color: lighten($idro-gallery-js, $type-lighten); }
    &.php { color: lighten($idro-skill-php, $type-lighten); }
    &.spring, &.spring_boot {
      color: lighten($idro-skill-spring, $type-lighten);
      background-image: url('https://tools.obyte.it/img/idrobyte/icon-spring-boot-green.svg');
      background-size: 100%;
      background-repeat: no-repeat;
      width: 28px;
      height: 28px;
      display: inline-block;
      margin: 5px 6px 0;
    }
  }
  #download-size-container {
    float: left;
  }
  #download-count-container {
    float: right;
  }
}

.tool-detail {
  padding: 10px 15px;
}

:global(.modal__view li) {
    list-style-position: inside;
}
</style>
